<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="sass">

.bulma
  @import "../node_modules/bulma/bulma"
  *
    box-sizing: border-box

</style>



// WEBPACK FOOTER //
// src/App.vue